// Public (pre-auth) Terms of Service page.
//
// Reachable WITHOUT signing in — the invitation email and the first-sign-in
// acceptance gate (RequireTerms) both link here so a person can read the
// Terms before agreeing to them. Renders the same bundled ToS the in-app docs
// viewer shows (/docs/terms-of-service), so there is a single source.

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import termsOfService from '@/docs/terms-of-service.md?raw';

export function PublicTermsPage() {
  return (
    <div className="min-h-full bg-card">
      <header className="border-b border-border bg-tres-header-bg text-white">
        <div className="container mx-auto flex h-14 items-center gap-3">
          <img src="/tres-logo.png" alt="TReS" className="h-8 w-8 rounded" draggable={false} />
          <span className="text-xl font-semibold tracking-tight">TReS</span>
          <span className="text-sm text-white/90">LLM Grounding Platform</span>
        </div>
      </header>
      <main className="container mx-auto py-8">
        <article className="prose prose-slate max-w-3xl dark:prose-invert prose-a:text-tres-action">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{termsOfService}</ReactMarkdown>
        </article>
        <p className="mt-8 max-w-3xl text-sm text-tres-text-secondary">
          <a href="/" className="text-tres-action hover:underline">
            Return to sign in
          </a>
        </p>
      </main>
    </div>
  );
}
